/**
 * PAPPO — Family Service
 * Grupo "Família" fechado/obrigatório (/api/family). Membros derivados dos
 * vínculos — sem adicionar/remover/sair. Só nome e foto são editáveis (adultos).
 */

import { apiGet, apiPut } from './api';
import type { Conversation } from '../types/message';

/** Grupo da família do usuário atual (null se ainda não há núcleo com 2+ membros) */
export async function getFamily() {
  return apiGet<{ family: Conversation | null }>('/family');
}

/** Renomeia e/ou troca a foto do grupo. `avatar_url` = /uploads/<uuid> (POST /uploads) */
export async function updateFamily(
  conversationId: number,
  patch: { name?: string; avatar_url?: string }
) {
  return apiPut<{ family: Conversation }>(`/family/${conversationId}`, patch);
}
